import AuthManager from '@/lib/AuthManager'

export default ({ headers, ...rest }) => {
  const Authorization = `Bearer ${AuthManager.token()}`

  return { headers: { ...headers, Authorization }, ...rest }
}
